var KEY_CODES = {
    ARROW_UP: {
        code: 38,
        key: 'ArrowUp',
    },
    ARROW_DOWN: {
        code: 40,
        key: 'ArrowDown',
    },
    BACKSPACE: {
        code: 8,
        key: 'Backspace',
    },
    DELETE: {
        code: 46,
        key: 'Delete',
    },
    ENTER: {
        code: 13,
        key: 'Enter',
    },
    ESCAPE: {
        code: 27,
        key: 'Escape',
    },
    SPACE: {
        code: 32,
        key: ' ',
    },
    TAB: {
        code: 9,
        key: 'Tab',
    },
};
Object.freeze(KEY_CODES);
export { KEY_CODES };
//# sourceMappingURL=keyCodes.js.map